export const IS_LOGGED_IN = 'IS_LOGGED_IN'

export const SUCCESS = 'SUCCESS'
export const SHOW_SUCCESS = 'SHOW_SUCCESS'

export const ERROR = 'ERROR'
export const SHOW_ERROR = 'SHOW_ERROR'

export const SHOW_LOADING = 'SHOW_LOADING'

export const SET_CLIENT_CONFIG = 'SET_CLIENT_CONFIG'
export const ADD_TASK = 'ADD_TASK'
export const REMOVE_TASK = 'REMOVE_TASK'
export const SET_BREADCRUMB = 'SET_BREADCRUMB'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'
export const SET_PDF = 'SHOW_PDF'
export const SET_MODAL = 'SHOW_MODAL'
